module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_pill-ecef097cddc0e9df05d7206c31a3bdb7.svg";